<script lang="ts">
    let canvas, ctx, gravity, sharkkuState, friction, flippu;
    const maxDrawings = 1000;
    let draws = 0;
    const sharkku = new Image();
    sharkku.src = "https://gateway.pinata.cloud/ipfs/QmfZ1DKyPwafftHRpMkYRU9jiuTWJPMraR7eLCWD7RDixt";

    function draw() {

        ctx.clearRect(0, 0, canvas.width, canvas.height);
        console.log('drawing', sharkkuState.x, sharkkuState.y, flippu);
        ctx.save();
        if (flippu) {
            ctx.restore();
            ctx.drawImage(sharkku, sharkkuState.x, sharkkuState.y);
        } else {
            flipHorizontally(sharkku, sharkkuState.x, sharkkuState.y);
        }
    }

    function flipHorizontally(img,x,y){
        // move to x + img's width
        ctx.translate(x+img.width,y);

        // scaleX by -1; this "trick" flips horizontally
        ctx.scale(-1,1);
        
        // draw the img
        // no need for x,y since we've already translated
        ctx.drawImage(img,0,0);
        
        // always clean up -- reset transformations to default
        ctx.setTransform(1,0,0,1,0,0);
    }

    function update() {
        if (draws >= maxDrawings) {
            console.log('finished');
            return;
        }
        // draws += 1;
        window.requestAnimationFrame(update);
         // bottom bound / floor
  if (sharkkuState.y >= canvas.height) {
    sharkkuState.velY = -sharkkuState.velY
    sharkkuState.y = canvas.height 
  }
  // top bound / ceiling
  if (sharkkuState.y <= 0) {
    sharkkuState.velY = -sharkkuState.velY
    sharkkuState.y = 0
  }

  // left bound
  if (sharkkuState.x <= 0) {
    sharkkuState.velX = -sharkkuState.velX
    sharkkuState.x = 0
    flippu = !flippu;
    // flippu = true;
  }
  // right bound
  if (sharkkuState.x >= canvas.width) {
    sharkkuState.velX = -sharkkuState.velX
    sharkkuState.x = canvas.width 
    flippu = !flippu;
  }
        // sharkkuState.velY += gravity;
        sharkkuState.x += sharkkuState.velX;
        sharkkuState.y += sharkkuState.velY;
        draw();
    }

    function initAquarium() {
        canvas = document.getElementById('aquarium');
        console.log('our canvas: ', canvas);
        ctx = canvas.getContext('2d');
        console.log('our ctx: ', ctx);
        canvas.width = 800
        canvas.height = 800

        gravity = 0.25
        friction = 0.98
        sharkkuState = {};

        sharkkuState.x = canvas.width / 2,
        sharkkuState.y =  canvas.height / 2,
        sharkkuState.velX = (Math.random() * 7 + 5) * (Math.floor(Math.random() * 1) || -1),
        sharkkuState.velY = (Math.random() * 8 + 5) * (Math.floor(Math.random() * 1) || -1)

        window.requestAnimationFrame(update)
    }
    document.addEventListener('DOMContentLoaded', initAquarium);

</script>

<main>
    <canvas
    id="aquarium"
    width="600"
    height="600"
    >
    </canvas>
</main>

<style>
    canvas {
        background: url('/images/coral.webp');
        padding: 0;
    }
</style>